"use client";

import { createContext, useState, useContext } from "react";
import { states, cities as allCities } from "../data/locations";

const LocationContext = createContext();

export const LocationProvider = ({ children }) => {
  const [cities, setCities] = useState([]);

  const getCities = (stateId) => {
    const filteredCities = allCities.filter((city) => city.stateId === stateId);
    setCities(filteredCities);
  };

  return (
    <LocationContext.Provider value={{ states, cities, getCities, setCities }}>
      {children}
    </LocationContext.Provider>
  );
};

export const useLocation = () => {
  return useContext(LocationContext);
};
